export default __webpack_public_path__ + "static/media/one-web.a9c2785d.svg";